import { get, post } from './axiosHelper';
import challengerEnv from '../lib/challengerEnv';
const securityPath = 'external/security-proxy/v1/api'
const acceptTermsAndConditions = async () => {
  const url = `${challengerEnv().apiBaseUrl}/${securityPath}/users/termsandconditions`;
  return await post(url, null);
};

const lastLogin = async () => {
  let lastLoginTime;
  if (challengerEnv().mockApiResponses) {
    return getMockResponse(require('../../cypress/fixtures/security/mock-last-login.json'));
  }

  const url = `${challengerEnv().apiBaseUrl}/${securityPath}/users/lastlogintime`;
  return await get(url);
};

const requestUserIdReminder = async function (email: String, mobile: String) {
  const url = `${challengerEnv().apiBaseUrl}/${securityPath}/forgotusername`;
  const requestBody = {
    email: email,
    mobilePhone: mobile,
  };
  if (challengerEnv().mockApiResponses) {
    return getMockResponse(require('../../cypress/fixtures/security/mock-forgotUserId-success.json'));
  }
  return await post(url, requestBody);
};

const changePassword = async (oldPassword, newPassword) => {
  const url = `${challengerEnv().apiBaseUrl}/${securityPath}/users/changepassword`;
  const requestBody = {
    oldPassword: oldPassword,
    newPassword: newPassword,
  };
  if (challengerEnv().mockApiResponses) {
    return getMockResponse(
      require('../../cypress/fixtures/security/mock-change-password-success.json')
    );
  }
  return await post(url, requestBody);
};

const getMockResponse = function (response) {
  return new Promise((resolve) => {
    setTimeout(() => resolve(response), Math.random() * 3000);
  });
};

export { acceptTermsAndConditions, lastLogin, changePassword, requestUserIdReminder };
